import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '@adsk/bim360-matrix-react-helpers/es/theme';

import './_ActivityLine.scss';

const ActivityLine = props => {
  const { theme } = useTheme();

  return (
    <div className={classNames('ActivityLine', props.className, `ActivityLine--${theme}`)}>
      {props.fieldName && <span className="ActivityLine__field-name">{props.fieldName}</span>}
      <span className="ActivityLine__field-value">{props.fieldValue}</span>
    </div>
  );
};

ActivityLine.propTypes = {
  /**
   * Class name to append to the container of this component
   */
  className: PropTypes.string,
  /**
   * The title of the changed field
   */
  fieldName: PropTypes.string,
  /**
   * A string or React node of the changed field's value
   */
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default ActivityLine;
